import { useState } from 'react';
import TangramGame, { DIFFICULTIES } from '../components/games/TangramGame';
import BackToMap from '../components/BackToMap';

/**
 * 七巧板页(/qiqiaoban):随机出一个图形,限制步数,用 7 块板拼出来。
 * 每道题由 seed 决定,「再来一个」换一个 seed;网址带 ?seed=123 可以打开指定的那道题。
 */
function randomSeed() {
  return Math.floor(Math.random() * 1e9);
}

function QiqiaobanPage() {
  const [seed, setSeed] = useState(
    () => Number(new URLSearchParams(window.location.search).get('seed')) || randomSeed(),
  );
  const [difficulty, setDifficulty] = useState('normal');

  return (
    <div className="min-h-screen bg-qiji-paper px-3 py-3">
      <div className="mx-auto flex max-w-md flex-col gap-3">
        <BackToMap />
        <header className="flex items-center justify-between gap-2 rounded-xl border-2 border-black bg-white px-3 py-2 shadow-brutal-sm">
          <h1 className="shrink-0 text-lg font-bold text-gray-900">🧩 七巧板</h1>
          <nav className="flex gap-1" aria-label="难度">
            {Object.entries(DIFFICULTIES).map(([id, d]) => (
              <button
                key={id}
                type="button"
                aria-pressed={id === difficulty}
                onClick={() => {
                  setDifficulty(id);
                  setSeed(randomSeed());
                }}
                className={`rounded-md border-2 border-black px-2 py-0.5 text-sm font-bold ${
                  id === difficulty ? 'bg-gray-900 text-white' : 'bg-white text-gray-800'
                }`}
              >
                {d.label}
              </button>
            ))}
          </nav>
        </header>

        <div className="rounded-2xl border-2 border-black bg-white p-3 shadow-brutal">
          {/* key 变化时整局重开 */}
          <TangramGame
            key={`${seed}-${difficulty}`}
            seed={seed}
            difficulty={difficulty}
            onNext={() => setSeed(randomSeed())}
          />
        </div>
      </div>
    </div>
  );
}

export default QiqiaobanPage;
